/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    gap: 8,
    hintColor: '#000000',
    hintFontName: 'StagSans',
    hintFontSize: 14,
    hintFontWeight: '400',
    hintLineHeight: 1.42857142857,
    lineHeight: 1.5
  }
}
export default theme
